import React, { useMemo } from 'react';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import { useTranslation } from 'react-i18next';

export function SensorAttributeSelect({
  label,
  name,
  multiple = false,
  sensorWithAttributes,
}) {
  const { t } = useTranslation();

  const options = useMemo(
    () =>
      sensorWithAttributes.map(({ name, sensor_attributes }) => ({
        label: name,
        title: name,
        options: sensor_attributes.map(({ id, label, attribute_unit }) => ({
          label: `${label} [${attribute_unit.unit}]`,
          value: id,
        })),
      })),
    [sensorWithAttributes],
  );

  return (
    <>
      <FormSelect
        label={label}
        name={name}
        {...(multiple ? { mode: 'multiple' } : {})}
        className="meteo-station-field"
        options={options}
        rules={[required(t)]}
      />
    </>
  );
}
